import React from 'react';
import { Route, Redirect } from 'react-router-dom';
// src
import * as routes from '../../routes/routes_production.js';

// se un componente è pubblico e viene visitato dopo il login,
// bisogna effettuare il redirect alla home page mediante la landing page 
const PublicRoute = ({component: Component, ...rest}) => (
    <Route {...rest} render={() => (rest.auth() === null)
      ? (
      	<Component {...rest} />      	
      )
      : <Redirect to={routes.LANDING} />
    } />
);

export default PublicRoute;


// WEBPACK FOOTER //
// ./src/cmp/Routing/PublicRoute.js